import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from './translate.service';

/**
 * Pipe for reactive translations.
 *
 * Wraps TranslateService for template usage with automatic updates
 * on language changes.
 */
@Pipe({
  name: 'translate',
  standalone: true,
})
export class TranslatePipe implements PipeTransform {

  #translateService = inject(TranslateService);

  transform(value: string, params?: Record<string, boolean|number|string|null|undefined>): string {
    return this.#translateService.translateAsSignal(value, params)();
  }
}
